import React from 'react';

import { useIntl } from 'ha/i18n';
import { Link, Typography } from '@hbf/dsl';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

export interface Props {
  track: {
    name: string;
  };
  link: {
    to: string;
    rel?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  };
  label: string;
}

const LinkItem: React.FC<Props> = ({
  track: { name },
  link: { to, rel, target },
  label,
}) => {
  const { T } = useIntl();

  return (
    <Track name={`Clicked ${name} in footer`} type="link">
      <Link
        to={to}
        rel={rel}
        target={target}
        data-test-locator="Footer/LinkItem"
      >
        <Typography.Paragraph color="white">{T(label)}</Typography.Paragraph>
      </Link>
    </Track>
  );
};

export { LinkItem };
